const PanCard = (props) => {
  const isPanVerified = props.$store?.user?.is_pan_code_verified;
  const handleAadharVerify = () => {
    swal2.fire({
      title: "Caution: PAN & Aadhaar Unlinked, TDS at 20%",
      text: "We've noticed your PAN & Aadhaar are unlinked. According to compliance, TDS will be 20%, not 5%.",
      icon: "info",
      iconColor: "#234C9B",
    });
  };
  return (
    <div className="card profile_card">
      <div className="card-header border-0">
        <div className="d-flex align-items-center">
          <div className="img_outer">
            <img src={imagepaths.panIcon} alt="pan" />
          </div>
          <h5 className="title ms-2">Pan</h5>
        </div>
        <div
          className={Object.className({
            "action_box d-flex align-items-center": true,
          })}
        >
          {isPanVerified ? (
            <i className="fa fa-check check_icon"></i>
          ) : (
            <button onClick={(...args) => props.onEdit(...args, "pan")}>
              <i className="fa fa-pencil"></i>
            </button>
          )}
        </div>
      </div>
      <div className="card-body">
        <h5>Name as per PAN</h5>
        <p>{props?.pandata?.name || "-"}</p>
        <h5>PAN No</h5>
        <p>{props?.pandata?.number || "-"}</p>
        <div className="d-flex justify-content-between">
          <div className="text_content_box">
            <h5>Aadhar Seeding Successful</h5>
            <p>
              {props?.pandata === null
                ? "-"
                : props?.pandata?.aadhaar_seeding_status === "Successful"
                ? "Yes"
                : "No"}
            </p>
          </div>
          {props?.pandata !== null &&
            props?.pandata?.aadhaar_seeding_status !== "Successful" && (
              <button
                type="button"
                className="btn info_btn"
                onClick={(...args) => handleAadharVerify(...args)}
              >
                <i className="fa fa-info"></i>
              </button>
            )}
        </div>
      </div>
    </div>
  );
};

export default constore(PanCard);
